import './App.css';
import {Route, BrowserRouter, Routes } from "react-router-dom";
import CookiesDialog from './cookiesdialog/CookiesDialog'
import HeaderForm from './header/Form'
import FooterForm from './footer/Form'
import React, {useState} from "react";
import {addLocale} from "primereact/api";
import UeberunsForm from './uberuns/Form'
import FaqForm from './faq/Form'
import ImpressumForm from './impressum/Form'
import DatenschutzForm from './datenschutz/Form'
import AgbForm from './agb/Form'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import PanelForm from "./panel/Form";


ModuleRegistry.registerModules([AllCommunityModule]);

export const UserContext = React.createContext(null);

function App() {

    const [trips, setTrips] = useState([]);
    const [selectedState, setSelectedState] = useState({code: null, name: 'Alle'});
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedAppointment, setSelectedAppointment] = useState(new Date().toISOString().substring(0, 10));

    addLocale('de', {
        firstDayOfWeek: 1,
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthNamesShort: ['Jan', 'Geb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Drp', 'Okt', 'Nov', 'Dez'],
        today: 'Heute',
        clear: 'Leer'
    });
  return (
    <div className="App">
        <CookiesDialog/>

            <BrowserRouter>
                <HeaderForm/>



                <div className="wrapper">
                    <PanelForm style={{background: '#FFFFFF', padding: 25}}>
                        <center>

                            <h1>Diese Website befindet sich derzeit im Aufbau.</h1>
                            <br/>
                            <div>
                                <b>Verantwortlich für den Inhalt gemäß § 5 TMG:</b><br/>
                                Ersoy Eren<br/>
                                Am Kalten Berg 15<br/>
                                60435 Frankfurt am Main<br/>
                                Telefon: +49 1575 4084582<br/>
                                E-Mail: mail@ersoyeren.de<br/>
                            </div>
                        </center>

                    </PanelForm>
                </div>
                <Routes>


                    <Route path="/ueberuns" element={
                        <UeberunsForm/>
                    }/>
                    <Route path="/faq" element={
                        <FaqForm/>
                    }/>
                    <Route path="/datenschutz" element={
                        <DatenschutzForm/>
                    }/>
                    <Route path="/impressum" element={
                        <ImpressumForm/>
                    }/>
                    <Route path="/agb" element={
                        <AgbForm/>
                    }/>
                </Routes>
                <FooterForm/>

            </BrowserRouter>
    </div>
  );
}

export default App;
